<div class="container">
  <mat-card style="margin-top: 50px" *ngIf="!doneRegistering">
    <mat-card-content style="margin-left: auto; margin-right: auto">
      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-10">
          <h1 class="mt-5">Register New Account</h1>
        </div>
      </div>
      <form
        *ngIf="registerForm"
        class="standard-form"
        [formGroup]="registerForm"
        (ngSubmit)="onSubmit()"
      >
        <div class="row">
          <div class="col-md-2"></div>
          <div class="col-md-8">
            <mat-form-field style="display: unset">
              <mat-label>Email</mat-label>
              <input
                matInput
                name="emailAddress"
                formControlName="emailAddress"
                [(ngModel)]="emailAddress"
                type="email"
                [ngClass]="{ 'is-invalid': submitted && f.emailAddress.errors }"
              />
            </mat-form-field>
            <div
              *ngIf="submitted && f.emailAddress.errors"
              class="invalid-feedback"
              style="display: unset"
            >
              <div *ngIf="f.emailAddress.errors.email">
                Invalid Email Address
              </div>
              <div *ngIf="f.emailAddress.errors.required">
                Email Address Required
              </div>
              <div *ngIf="f.emailAddress.errors.mustMatch">
                Email Addresses Must Match
              </div>
              <br />
            </div>
            <mat-form-field style="display: unset">
              <mat-label>Confirm Email</mat-label>
              <input
                matInput
                name="confirmEmailAddress"
                formControlName="confirmEmailAddress"
                [(ngModel)]="confirmEmailAddress"
                type="email"
                [ngClass]="{
                  'is-invalid': submitted && f.confirmEmailAddress.errors
                }"
              />
            </mat-form-field>
            <div
              *ngIf="submitted && f.confirmEmailAddress.errors"
              class="invalid-feedback"
              style="display: unset"
            >
              <div *ngIf="f.confirmEmailAddress.errors.email">
                Invalid Email Address
              </div>
              <div *ngIf="f.confirmEmailAddress.errors.required">
                Email Address Required
              </div>
              <div *ngIf="f.confirmEmailAddress.errors.mustMatch">
                Email Addresses Must Match
              </div>
              <br />
            </div>
            <mat-form-field style="display: unset">
              <mat-label>Password</mat-label>
              <input
                matInput
                name="password"
                formControlName="password"
                [(ngModel)]="password"
                type="password"
                [ngClass]="{ 'is-invalid': submitted && f.password.errors }"
              />
            </mat-form-field>
            <div
              *ngIf="submitted && f.password.errors"
              class="invalid-feedback"
              style="display: unset"
            >
              <div *ngIf="f.password.errors.required">Password Required</div>
              <div *ngIf="f.password.errors.mustMatch">
                Passwords Must Match
              </div>
              <br />
            </div>
            <mat-form-field style="display: unset">
              <mat-label>Confirm Password</mat-label>
              <input
                matInput
                name="confirmPassword"
                formControlName="confirmPassword"
                [(ngModel)]="confirmPassword"
                type="password"
                [ngClass]="{
                  'is-invalid': submitted && f.confirmPassword.errors
                }"
              />
            </mat-form-field>
            <div
              *ngIf="submitted && f.confirmPassword.errors"
              class="invalid-feedback"
              style="display: unset"
            >
              <div *ngIf="f.confirmPassword.errors.required">
                Password Required
              </div>
              <div *ngIf="f.confirmPassword.errors.mustMatch">
                Passwords Must Match
              </div>
              <br />
            </div>
            <mat-form-field style="display: unset">
              <mat-label>First Name</mat-label>
              <input
                matInput
                name="firstName"
                formControlName="firstName"
                [(ngModel)]="firstName"
                [ngClass]="{ 'is-invalid': submitted && f.firstName.errors }"
              />
            </mat-form-field>
            <div
              *ngIf="submitted && f.firstName.errors"
              class="invalid-feedback"
              style="display: unset"
            >
              <div *ngIf="f.firstName.errors.required">First Name Required</div>
              <br />
            </div>
            <mat-form-field style="display: unset">
              <mat-label>Last Name</mat-label>
              <input
                matInput
                name="lastName"
                formControlName="lastName"
                [(ngModel)]="lastName"
                [ngClass]="{ 'is-invalid': submitted && f.lastName.errors }"
              />
            </mat-form-field>
            <div
              *ngIf="submitted && f.lastName.errors"
              class="invalid-feedback"
              style="display: unset"
            >
              <div *ngIf="f.lastName.errors.required">Last Name Required</div>
              <br />
            </div>
            <mat-form-field style="display: unset">
              <mat-label>Title</mat-label>
              <input
                matInput
                name="title"
                formControlName="title"
                [(ngModel)]="title"
                [ngClass]="{ 'is-invalid': submitted && f.title.errors }"
              />
            </mat-form-field>
            <mat-form-field style="display: unset">
              <mat-label>Organization</mat-label>
              <input
                matInput
                name="organization"
                formControlName="organization"
                [(ngModel)]="organization"
                [ngClass]="{ 'is-invalid': submitted && f.organization.errors }"
              />
            </mat-form-field>
            <div
              *ngIf="submitted && f.organization.errors"
              class="invalid-feedback"
              style="display: unset"
            >
              <div *ngIf="f.organization.errors.required">
                Organization Required
              </div>
              <br />
            </div>
            <mat-form-field style="display: unset">
              <mat-label>Address1</mat-label>
              <input
                matInput
                name="address1"
                formControlName="address1"
                [(ngModel)]="address1"
                [ngClass]="{ 'is-invalid': submitted && f.address1.errors }"
              />
            </mat-form-field>
            <div
              *ngIf="submitted && f.address1.errors"
              class="invalid-feedback"
              style="display: unset"
            >
              <div *ngIf="f.address1.errors.required">Address 1 Required</div>
              <br />
            </div>
            <mat-form-field style="display: unset">
              <mat-label>Address2</mat-label>
              <input
                matInput
                name="address2"
                formControlName="address2"
                [(ngModel)]="address2"
                [ngClass]="{ 'is-invalid': submitted && f.address2.errors }"
              />
            </mat-form-field>
            <mat-form-field style="display: unset">
              <mat-label>City</mat-label>
              <input
                matInput
                name="city"
                formControlName="city"
                [(ngModel)]="city"
                [ngClass]="{ 'is-invalid': submitted && f.city.errors }"
              />
            </mat-form-field>
            <div
              *ngIf="submitted && f.city.errors"
              class="invalid-feedback"
              style="display: unset"
            >
              <div *ngIf="f.city.errors.required">City Required</div>
              <br />
            </div>
            <mat-form-field style="display: unset">
              <mat-label>State</mat-label>
              <input
                matInput
                name="state"
                formControlName="state"
                [(ngModel)]="state"
                [ngClass]="{ 'is-invalid': submitted && f.state.errors }"
              />
            </mat-form-field>
            <div
              *ngIf="submitted && f.state.errors"
              class="invalid-feedback"
              style="display: unset"
            >
              <div *ngIf="f.state.errors.required">First Name Required</div>
              <div *ngIf="f.state.errors.minlength">
                Must Be Exactly 2 Characters
              </div>
              <div *ngIf="f.state.errors.maxlength">
                Must Be Exactly 2 Characters
              </div>
              <br />
            </div>
            <mat-form-field style="display: unset">
              <mat-label>Zip</mat-label>
              <input
                matInput
                name="zip"
                formControlName="zip"
                [(ngModel)]="zip"
                [ngClass]="{ 'is-invalid': submitted && f.zip.errors }"
              />
            </mat-form-field>
            <div
              *ngIf="submitted && f.zip.errors"
              class="invalid-feedback"
              style="display: unset"
            >
              <div *ngIf="f.zip.errors.required">Zip Required</div>
              <br />
            </div>
            <mat-form-field style="display: unset">
              <mat-label>Phone</mat-label>
              <input
                matInput
                name="phone"
                formControlName="phone"
                [(ngModel)]="phone"
                [ngClass]="{ 'is-invalid': submitted && f.phone.errors }"
              />
            </mat-form-field>
            <div
              *ngIf="submitted && f.phone.errors"
              class="invalid-feedback"
              style="display: unset"
            >
              <div *ngIf="f.phone.errors.required">Phone Required</div>
              <br />
            </div>
          </div>
          <div class="col-md-2"></div>
        </div>
        <div class="row">
          <div class="col-md-2"></div>
          <div class="col-md-8">
            <span style="color: red">{{ errorMessage }}</span>
          </div>
          <div class="col-md-2"></div>
        </div>
        <div class="row">
          <div class="col-md-6"></div>
          <div class="col-md-4">
            <button mat-raised-button class="piButton">Register</button>
          </div>
          <div class="col-md-2"></div>
        </div>
      </form>
    </mat-card-content>
  </mat-card>

  <mat-card style="margin-top: 50px" *ngIf="doneRegistering">
    <mat-card-content>
      <p>
        Registration complete, you will received an email to verify your
        address, follow the instructions there to verify your account.
      </p>
      <p>
        If you don't find the email in your inbox, please check your spam
        folder.
      </p>
    </mat-card-content>
  </mat-card>
</div>
